import { ConfirmDialog } from '@/components/ConfirmDialog/ConfirmDialog';
import { t } from '@/lib/i18n';

interface DeleteConfirmDialogProps {
  itemLabel: string;
  memberCount: number;
  memberNoun: string;
  isPending: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmDialog({
  itemLabel,
  memberCount,
  memberNoun,
  isPending,
  error,
  onCancel,
  onConfirm,
}: DeleteConfirmDialogProps) {
  const description =
    memberCount > 0
      ? t('Delete {label}? This will remove it from {n} {noun}.', {
          label: itemLabel,
          n: String(memberCount),
          noun: memberNoun,
        })
      : t('Delete {label}?', { label: itemLabel });

  return (
    <ConfirmDialog
      open
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title={t('Delete')}
      description={description}
      confirmVariant="danger"
      confirmLabel={t('Delete')}
      pendingLabel={t('Deleting…')}
      isPending={isPending}
      error={error ?? null}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
